import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'includesObject'
})
export class IncludesObjectPipe implements PipeTransform {

  transform(array: any[], value: any, fieldCheck: string = 'id', childFieldCheck: string = ''): boolean {
    const check = (a: any) => {
      return a[fieldCheck] == value[fieldCheck]
        || (childFieldCheck && a[childFieldCheck] && a[childFieldCheck]?.some((c: any) => check(c)))
    }
    return array.some(a => check(a))
  }

}
